// @flow
import ActionTypes from './action-types';
import type { ProjectSummaryWeeklyAction } from './sagas';

export type ProjectSummaryWeeklyState = {
  data: {
    "actual_progress": number,
    "expected_completion_date": string,
    "overall_status": string,
    "planned_completion_date": string,
    "planned_progress": number,
    project_name: string,
  } | {},
  loading: boolean | null,
};

const initialState: ProjectSummaryWeeklyState = { loading: null, data: {} };

export default function (state: ProjectSummaryWeeklyState = initialState, action: ProjectSummaryWeeklyAction): ProjectSummaryWeeklyState {
  switch (action.type) {
    case ActionTypes.GET_PROJECT_SUMMARY_WEEKLY_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    default:
      return state;
  }
}
